import client from "./axios";

const PLACES_BASE_URL = "https://internal-api.getmoveapp.com/api/v1/places";

export const Google = {
  fetchCities: (params: { input: string; types?: string }) =>
    client.get<any>(PLACES_BASE_URL, {
      params,
    }),
  getPlaceDetails: (params: { place_id: string }) =>
    client.get(`${PLACES_BASE_URL}/infos`, {
      params,
    }),
};
